// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_-br","controls":"styles_controls__15HAn","charLimit":"styles_charLimit__28IuB","input":"styles_input__1og9o","send":"styles_send__4MbWp"};